import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChartName from "../../Dashboard/Charts/ChartName";
import NoData from "../../Dashboard/Charts/NoData/NoData";
import moment from "moment";

import Highcharts from "highcharts";
import HighchartsCustomEvents from "highcharts-custom-events";
import WordcloudChart from "../../Dashboard/Charts/OcrWordCloud/WordcloudChart";
import { Dimmer, Loader, Icon } from "semantic-ui-react";
import { QuestionLists } from "../HomePage/Header/InsightsTabComponent";

HighchartsCustomEvents(Highcharts);

const OCRWordcloud = (props) => {
    const brandTopicObj = useSelector((state) => state.insightsRecommendationReducer.ownBrand);
    const competitorTopicObj = useSelector((state) => state.insightsRecommendationReducer.competitorsBrand);
    const topic1Data = useSelector((state) => state.insightsRecommendationReducer.chartData.ocrWordcloud?.own);
    const topic1DataLoading = useSelector((state) => state.insightsRecommendationReducer.chartDataLoading?.ocrWordcloud?.own);
    const topic2Data = useSelector((state) => state.insightsRecommendationReducer.chartData.ocrWordcloud?.competitor);
    const topic2DataLoading = useSelector((state) => state.insightsRecommendationReducer.chartDataLoading?.ocrWordcloud?.competitor);
    const currentPage = useSelector((state) => state.insightsRecommendationReducer.currentPage);

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    let range = moment().tz(tz).subtract(7, "days").format("DD-MM-YYYY") + ` to ` + moment().tz(tz).subtract(1, "days").format("DD-MM-YYYY");
    let widgetContainerRef1 = useRef(null);
    let widgetContainerRef2 = useRef(null);
    let question = QuestionLists.find((obj) => obj.questionTab === currentPage)?.question || "";

    const getWordCloudChart = (data, loading, topic, widgetContainerRef) => {
        let nodata = !data || (data && data.length === 0);
        let topicName = topic === "topic1" ? "OCR Wordcloud for own brand" : "OCR Wordcloud for competitor brand";
        let info =
            topic === "topic1"
                ? "This chart will show you the most used keywords in the conversation happening around your brand in last week"
                : "This chart will show you the most used keywords in the conversation happening around your competitor brand in last week";

        return (
            <>
                <div className={`dashboard-widget-container }`} ref={widgetContainerRef}>
                    <div className="dashboard-widget-container-header skiptranslate ocr__owncloud">
                        <ChartName name={topicName} info={info} chatGPT={true} />
                    </div>
                    {loading ? (
                        <div className="no__data__block">
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        </div>
                    ) : !nodata ? (
                        <div className="dashboard-chart wordcloud-chart skiptranslate ">
                            <WordcloudChart
                                // showContextMenu={this.showContextMenu}
                                // drillDown={this.drillDown}
                                data={data}
                                selectedWord={[]}
                                appliedFilter={{ aggs: "ocr-frequency-wordcloud" }}
                                hasDrilldownWords={0}
                                // onChangeSelectedWord={this.onChangeSelectedWord}
                                // // resizedCount={this.props.resizedCount}
                                widgetContainerRef={widgetContainerRef}
                                insights__recommendation
                            />
                            {/* {this.state.downloading && <DimmerComponent />} */}
                        </div>
                    ) : (
                        <>
                            <NoData classname="gpt__no__data" />
                        </>
                    )}
                </div>
            </>
        );
    };

    return (
        <>
            <div className={`ocr__wordcloud__wrapper column__flex`}>
                <div className="gptHeader">
                    <div className="top">
                        <div>{question} </div>
                    </div>
                    <div className="lower">{`From date: ${range}`}</div>
                </div>
                {brandTopicObj ? getWordCloudChart(topic1Data, topic1DataLoading, "topic1", widgetContainerRef1) : null}
                {competitorTopicObj ? getWordCloudChart(topic2Data, topic2DataLoading, "topic2", widgetContainerRef2) : null}
            </div>
        </>
    );
};

export default OCRWordcloud;
